module.exports = __webpack_public_path__ + "static/media/shoppingCart.bc8d8d9e.svg";